export default "__VITE_ASSET__DvY_MTWV__"